import eventBus from '../helpers/event-bus';
import calculatorEventNames from '../events/calculator-event-names';
import api from '../services/api';

(() => {
  eventBus.on(calculatorEventNames.CALCULATOR_CHANGE_CURRENCY, ({ cryptoCurrency, fiatCurrency }) => {
    api
      .get(`/calculator/text-block/?cryptoCode=${cryptoCurrency.code}&fiatCode=${fiatCurrency.code}`)
      .then(({ data }) => {
        const { text } = data;
        const textBlockWrapper = document.getElementById('calculator-text-block');
        if (text === null) {
          textBlockWrapper.innerHTML = '';

          return;
        }
        const textBlock = document.createElement('div');
        textBlock.className = 'text-block';
        textBlock.innerHTML = text;
        textBlockWrapper.innerHTML = textBlock.outerHTML;
    });
  });
})();
